export default "__VITE_ASSET__CttlOnYT__"